import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SocialLinkedinIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M20.5576 1.99988H3.44241C2.64575 1.99988 2 2.64563 2 3.44229V20.5575C2 21.3541 2.64575 21.9999 3.44241 21.9999H20.5576C21.3542 21.9999 22 21.3541 22 20.5575V3.44229C22 2.64563 21.3542 1.99988 20.5576 1.99988V1.99988ZM9.09412 17.1171H6.65866V9.78995H9.09412V17.1171ZM7.87646 8.78943H7.8606C7.04333 8.78943 6.51477 8.22684 6.51477 7.52371C6.51477 6.80472 7.05951 6.25769 7.89264 6.25769C8.72577 6.25769 9.23846 6.80472 9.25433 7.52371C9.25433 8.22684 8.72577 8.78943 7.87646 8.78943ZM17.8759 17.1171H15.4407V13.1972C15.4407 12.2121 15.0881 11.5403 14.2069 11.5403C13.5341 11.5403 13.1334 11.9935 12.9573 12.4309C12.8929 12.5875 12.8772 12.8063 12.8772 13.0253V17.1171H10.4419C10.4419 17.1171 10.4738 10.4774 10.4419 9.78995H12.8772V10.8274C13.2009 10.3281 13.7799 9.61798 15.0721 9.61798C16.6744 9.61798 17.8759 10.6652 17.8759 12.9157V17.1171Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
